import { isAccountSharingReadonlyMode } from 'system/SystemUtil';
import { createMenuItem } from 'utils/navigation/helpers';

const buildDashboardMenuSection = ({ userType }) =>
    [
        createMenuItem({
            title: 'main_header_home_text',
            translationNamespace: 'main_container',
            icon: 'home',
            url: `/home`
        }),
        createMenuItem({
            title: 'title_calendar_widget',
            translationNamespace: 'widgets',
            icon: 'calendar',
            url: '/calendar',
            condition: userType.isRaceEventProvider
        }),
        createMenuItem({
            title: 'title_challenge_widget',
            translationNamespace: 'widgets',
            icon: 'challenges',
            url: '/challenge',
            urlKeyword: 'challenge/',
            disabled: isAccountSharingReadonlyMode(),
            condition: userType.isFitness || userType.isWellness || userType.isDive
        }),
        createMenuItem({
            title: 'title_calendar_widget',
            translationNamespace: 'widgets',
            icon: 'calendar',
            url: '/calendar',
            condition: userType.isFitness || userType.isWellness || userType.isDive
        }),
        createMenuItem({
            title: 'news_feed',
            translationNamespace: 'connections',
            icon: 'newsfeed',
            url: '/newsfeed',
            disabled: isAccountSharingReadonlyMode(),
            condition: userType.isFitness || userType.isWellness || userType.isDive || userType.isOutdoor
        })
    ].flat();

export default buildDashboardMenuSection;
